import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { BrandHub } from './pages/BrandHub';
import { Transactions } from './pages/Transactions';
import { Marketplace } from './pages/Marketplace';
import { Orders } from './pages/Orders';
import { Invoicing } from './pages/Invoicing';
import { Storefront } from './pages/Storefront';
import { Affiliates } from './pages/Affiliates';
import { AppCenter } from './pages/AppCenter';
import { AddProduct } from './pages/AddProduct';
import { Customers } from './pages/Customers';
import { Payouts } from './pages/Payouts';
import { Reports } from './pages/Reports';
import { Pricing } from './pages/Pricing';
import { Login } from './pages/Login';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeTab, setActiveTab] = useState('dashboard');
  if (!isAuthenticated) {
    return <Login onLogin={() => setIsAuthenticated(true)} data-id="element-0" />;
  }
  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard data-id="element-1" />;
      case 'brand-hub':
        return <BrandHub data-id="element-2" />;
      case 'transactions':
        return <Transactions data-id="element-3" />;
      case 'orders':
        return <Orders data-id="element-4" />;
      case 'customers':
        return <Customers data-id="element-5" />;
      case 'payouts':
        return <Payouts data-id="element-6" />;
      case 'pricing':
        return <Pricing data-id="element-7" />;
      case 'invoicing':
        return <Invoicing data-id="element-8" />;
      case 'storefront':
        return <Storefront data-id="element-9" />;
      case 'affiliates':
        return <Affiliates data-id="element-10" />;
      case 'app-center':
        return <AppCenter data-id="element-11" />;
      case 'add-product':
        return <AddProduct data-id="element-12" />;
      case 'reports':
        return <Reports data-id="element-13" />;
      default:
        return <div className="flex flex-col items-center justify-center h-[60vh] text-slate-400" data-id="element-14">
            <p className="text-lg font-medium" data-id="element-15">
              Section "{activeTab}" is under development
            </p>
            <button onClick={() => setActiveTab('dashboard')} className="mt-4 text-blue-600 font-bold hover:underline" data-id="element-16">
              Back to Dashboard
            </button>
          </div>;
    }
  };
  return <Layout activeTab={activeTab} setActiveTab={setActiveTab} onLogout={() => setIsAuthenticated(false)} data-id="element-17">
      {renderContent()}
    </Layout>;
}